import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Serializer, Client, LocalStorage, TransportStatus, WalletP2PTransport } from '../..';
import { PermissionManager } from '../../managers/PermissionManager';
import { AppMetadataManager } from '../../managers/AppMetadataManager';
import { IncomingRequestInterceptor } from '../../interceptors/IncomingRequestInterceptor';
import { OutgoingResponseInterceptor } from '../../interceptors/OutgoingResponseInterceptor';
import { BeaconMessageType } from '../../types/beacon/BeaconMessageType';
import { getSenderId } from '../../utils/get-sender-id';
import { ExposedPromise } from '../../utils/exposed-promise';
import { Logger } from '../../utils/Logger';
var logger = new Logger('WalletClient');
/**
 * @publicapi
 *
 * The WalletClient has to be used in the wallet. It handles all the logic related to connecting to beacon-compatible
 * dapps and handling/responding to requests.
 *
 * @category Wallet
 */

export var WalletClient = /*#__PURE__*/function (_Client) {
  _inherits(WalletClient, _Client);

  var _super2 = _createSuper(WalletClient);

  function WalletClient(config) {
    var _this;

    _classCallCheck(this, WalletClient);

    _this = _super2.call(this, Object.assign({
      storage: new LocalStorage()
    }, config));
    /**
     * Returns whether or not the transport is connected
     */

    _this._isConnected = new ExposedPromise();
    /**
     * This array stores pending requests, meaning requests we received and have not yet handled / sent a response.
     */

    _this.pendingRequests = [];
    _this.permissionManager = new PermissionManager(new LocalStorage());
    _this.appMetadataManager = new AppMetadataManager(new LocalStorage());
    return _this;
  }

  _createClass(WalletClient, [{
    key: "isConnected",
    get: function get() {
      return this._isConnected.promise;
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      var _super = Object.create(null, {
        init: {
          get: function get() {
            return _get(_getPrototypeOf(WalletClient.prototype), "init", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var keyPair, p2pTransport;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.keyPair;

              case 2:
                keyPair = _context.sent;
                // We wait for keypair here so the P2P Transport creation is not delayed and causing issues
                p2pTransport = new WalletP2PTransport(this.name, keyPair, this.storage, this.matrixNodes, this.iconUrl, this.appUrl);
                return _context.abrupt("return", _super.init.call(this, p2pTransport));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * This method initiates a connection to the P2P network and registers a callback that will be called
     * whenever a message is received.
     *
     * @param newMessageCallback The callback that will be invoked for every message the transport receives.
     */

  }, {
    key: "connect",
    value: function connect(newMessageCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.handleResponse = function (message, connectionContext) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var transport, peers, peer;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(message.type === BeaconMessageType.Disconnect)) {
                              _context2.next = 12;
                              break;
                            }

                            _context2.next = 3;
                            return this.transport;

                          case 3:
                            transport = _context2.sent;
                            _context2.next = 6;
                            return transport.getPeers();

                          case 6:
                            peers = _context2.sent;
                            peer = peers.find(function (peerEl) {
                              return peerEl.senderId === message.senderId;
                            });

                            if (!peer) {
                              _context2.next = 11;
                              break;
                            }

                            _context2.next = 11;
                            return this.removePeer(peer);

                          case 11:
                            return _context2.abrupt("return");

                          case 12:
                            if (this.pendingRequests.some(function (request) {
                              return request[0].id === message.id;
                            })) {
                              _context2.next = 19;
                              break;
                            }

                            this.pendingRequests.push([message, connectionContext]);

                            if (!(message.version !== '1')) {
                              _context2.next = 17;
                              break;
                            }

                            _context2.next = 17;
                            return this.sendAcknowledgeResponse(message, connectionContext);

                          case 17:
                            _context2.next = 19;
                            return IncomingRequestInterceptor.intercept({
                              message: message,
                              connectionInfo: connectionContext,
                              appMetadataManager: this.appMetadataManager,
                              interceptorCallback: newMessageCallback
                            });

                          case 19:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));
                };

                return _context3.abrupt("return", this._connect());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * The method will attempt to initiate a connection using the active transport.
     */

  }, {
    key: "_connect",
    value: function _connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;

        var transport;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.transport;

              case 2:
                transport = _context5.sent;

                if (!(transport.connectionStatus === TransportStatus.NOT_CONNECTED)) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 6;
                return transport.connect();

              case 6:
                transport.addListener(function (message, connectionInfo) {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                    var deserializedMessage;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!(typeof message === 'string')) {
                              _context4.next = 5;
                              break;
                            }

                            _context4.next = 3;
                            return new Serializer().deserialize(message);

                          case 3:
                            deserializedMessage = _context4.sent;
                            this.handleResponse(deserializedMessage, connectionInfo);

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, this);
                  }));
                }).catch(function (error) {
                  return logger.log('_connect', error);
                });

                this._isConnected.resolve(true);

                _context5.next = 10;
                break;

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * This method sends a response for a specific request back to the DApp
     *
     * @param message The BeaconResponseMessage that will be sent back to the DApp
     */

  }, {
    key: "respond",
    value: function respond(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this5 = this;

        var request;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                request = this.pendingRequests.find(function (pendingRequest) {
                  return pendingRequest[0].id === message.id;
                });

                if (request) {
                  _context7.next = 3;
                  break;
                }

                throw new Error('No matching request found!');

              case 3:
                this.pendingRequests = this.pendingRequests.filter(function (pendingRequest) {
                  return pendingRequest[0].id !== message.id;
                });
                _context7.t0 = OutgoingResponseInterceptor;
                _context7.t1 = getSenderId;
                _context7.next = 8;
                return this.beaconId;

              case 8:
                _context7.t2 = _context7.sent;
                _context7.next = 11;
                return (0, _context7.t1)(_context7.t2);

              case 11:
                _context7.t3 = _context7.sent;
                _context7.t4 = request[0];
                _context7.t5 = message;
                _context7.next = 16;
                return this.getOwnAppMetadata();

              case 16:
                _context7.t6 = _context7.sent;
                _context7.t7 = this.permissionManager;
                _context7.t8 = this.appMetadataManager;

                _context7.t9 = function interceptorCallback(response) {
                  return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return this.respondToMessage(response, request[1]);

                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));
                };

                _context7.t10 = {
                  senderId: _context7.t3,
                  request: _context7.t4,
                  message: _context7.t5,
                  ownAppMetadata: _context7.t6,
                  permissionManager: _context7.t7,
                  appMetadataManager: _context7.t8,
                  interceptorCallback: _context7.t9
                };
                _context7.next = 23;
                return _context7.t0.intercept.call(_context7.t0, _context7.t10);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getAppMetadataList",
    value: function getAppMetadataList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.appMetadataManager.getAppMetadataList());

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "getAppMetadata",
    value: function getAppMetadata(senderId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.appMetadataManager.getAppMetadata(senderId));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "removeAppMetadata",
    value: function removeAppMetadata(senderId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.appMetadataManager.removeAppMetadata(senderId));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "removeAllAppMetadata",
    value: function removeAllAppMetadata() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this.appMetadataManager.removeAllAppMetadata());

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.permissionManager.getPermissions());

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "getPermission",
    value: function getPermission(accountIdentifier) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.permissionManager.getPermission(accountIdentifier));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "removePermission",
    value: function removePermission(accountIdentifier) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.permissionManager.removePermission(accountIdentifier));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "removeAllPermissions",
    value: function removeAllPermissions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.permissionManager.removeAllPermissions());

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
    /**
     * Add a new peer to the known peers
     * @param peer The new peer to add
     */

  }, {
    key: "addPeer",
    value: function addPeer(peer) {
      var sendPairingResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var extendedPeer;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.t0 = Object;
                _context16.t1 = Object.assign({}, peer);
                _context16.next = 4;
                return getSenderId(peer.publicKey);

              case 4:
                _context16.t2 = _context16.sent;
                _context16.t3 = {
                  senderId: _context16.t2
                };
                extendedPeer = _context16.t0.assign.call(_context16.t0, _context16.t1, _context16.t3);
                _context16.next = 9;
                return this.transport;

              case 9:
                return _context16.abrupt("return", _context16.sent.addPeer(extendedPeer, sendPairingResponse));

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "removePeer",
    value: function removePeer(peer) {
      var sendDisconnectToPeer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var removePeerResult;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.transport;

              case 2:
                removePeerResult = _context17.sent.removePeer(peer);
                _context17.next = 5;
                return this.removePermissionsForPeers([peer]);

              case 5:
                if (!sendDisconnectToPeer) {
                  _context17.next = 8;
                  break;
                }

                _context17.next = 8;
                return this.sendDisconnectToPeer(peer);

              case 8:
                return _context17.abrupt("return", removePeerResult);

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "removeAllPeers",
    value: function removeAllPeers() {
      var sendDisconnectToPeers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _this6 = this;

        var peers, removePeerResult, disconnectPromises;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.transport;

              case 2:
                _context18.next = 4;
                return _context18.sent.getPeers();

              case 4:
                peers = _context18.sent;
                _context18.next = 7;
                return this.transport;

              case 7:
                removePeerResult = _context18.sent.removeAllPeers();
                _context18.next = 10;
                return this.removePermissionsForPeers(peers);

              case 10:
                if (!sendDisconnectToPeers) {
                  _context18.next = 14;
                  break;
                }

                disconnectPromises = peers.map(function (peer) {
                  return _this6.sendDisconnectToPeer(peer);
                });
                _context18.next = 14;
                return Promise.all(disconnectPromises);

              case 14:
                return _context18.abrupt("return", removePeerResult);

              case 15:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "removePermissionsForPeers",
    value: function removePermissionsForPeers(peersToRemove) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var permissions, peerIdsToRemove, permissionsToRemove, permissionIdentifiersToRemove;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.permissionManager.getPermissions();

              case 2:
                permissions = _context19.sent;
                peerIdsToRemove = peersToRemove.map(function (peer) {
                  return peer.senderId;
                }); // Remove all permissions with origin of the specified peer

                permissionsToRemove = permissions.filter(function (permission) {
                  return peerIdsToRemove.includes(permission.appMetadata.senderId);
                });
                permissionIdentifiersToRemove = permissionsToRemove.map(function (permissionInfo) {
                  return permissionInfo.accountIdentifier;
                });
                _context19.next = 8;
                return this.permissionManager.removePermissions(permissionIdentifiersToRemove);

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * Send an acknowledge message back to the sender
     *
     * @param message The message that was received
     */

  }, {
    key: "sendAcknowledgeResponse",
    value: function sendAcknowledgeResponse(request, connectionContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this7 = this;

        var acknowledgeResponse;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                // Acknowledge the message
                acknowledgeResponse = {
                  id: request.id,
                  type: BeaconMessageType.Acknowledge
                };
                _context21.t0 = OutgoingResponseInterceptor;
                _context21.t1 = getSenderId;
                _context21.next = 5;
                return this.beaconId;

              case 5:
                _context21.t2 = _context21.sent;
                _context21.next = 8;
                return (0, _context21.t1)(_context21.t2);

              case 8:
                _context21.t3 = _context21.sent;
                _context21.t4 = request;
                _context21.t5 = acknowledgeResponse;
                _context21.next = 13;
                return this.getOwnAppMetadata();

              case 13:
                _context21.t6 = _context21.sent;
                _context21.t7 = this.permissionManager;
                _context21.t8 = this.appMetadataManager;

                _context21.t9 = function interceptorCallback(response) {
                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            _context20.next = 2;
                            return this.respondToMessage(response, connectionContext);

                          case 2:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20, this);
                  }));
                };

                _context21.t10 = {
                  senderId: _context21.t3,
                  request: _context21.t4,
                  message: _context21.t5,
                  ownAppMetadata: _context21.t6,
                  permissionManager: _context21.t7,
                  appMetadataManager: _context21.t8,
                  interceptorCallback: _context21.t9
                };
                _context21.next = 20;
                return _context21.t0.intercept.call(_context21.t0, _context21.t10);

              case 20:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * An internal method to send a BeaconMessage to the DApp
     *
     * @param response Send a message back to the DApp
     */

  }, {
    key: "respondToMessage",
    value: function respondToMessage(response, connectionContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var serializedMessage, peerInfos, peer;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return new Serializer().serialize(response);

              case 2:
                serializedMessage = _context22.sent;

                if (!connectionContext) {
                  _context22.next = 14;
                  break;
                }

                _context22.next = 6;
                return this.getPeers();

              case 6:
                peerInfos = _context22.sent;
                peer = peerInfos.find(function (peerInfo) {
                  return peerInfo.publicKey === connectionContext.id;
                });
                _context22.next = 10;
                return this.transport;

              case 10:
                _context22.next = 12;
                return _context22.sent.send(serializedMessage, peer);

              case 12:
                _context22.next = 18;
                break;

              case 14:
                _context22.next = 16;
                return this.transport;

              case 16:
                _context22.next = 18;
                return _context22.sent.send(serializedMessage);

              case 18:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }]);

  return WalletClient;
}(Client);